<template>
	<div class="flex flex-col gap-casual-friends">
		<h2 class="typography-h3-str">
			{{ title }}
		</h2>
		<div class="flex flex-col gap-[32px]">
			<div
				v-for="(row, rowIndex) in groupedData"
				:key="rowIndex"
				class="flex flex-col justify-center gap-casual-friends mdp:flex-row mdp:flex-row mdp:gap-x-[20px]"
			>
				<CampaignCard
					v-for="(blog, i) in row"
					class="basis-1/3"
					:key="i"
					:blog="blog"
					:pageContent="pageContent"
					:isDataLoaded="isDataLoaded"
					@click="onClickItem(blog)"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { type PropType, computed } from 'vue'
import CampaignCard from '@/components/ui/campaignCard/CampaignCard.vue'
import type { ICampaignCard } from '@/components/ui/campaignCard/CampaignCard.vue'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

const props = defineProps({
	title: {
		type: String,
		required: true,
	},
	section: {
		type: Array as PropType<ICampaignCard[]>,
		default: () => [],
	},
	pageContent: {
		type: Object as PropType<{ [key: string]: string }>,
		required: true,
	},
})

const isDataLoaded = computed(() => {
	return !!props.section.length
})

const groupedData = computed(() => {
	const rows = []
	for (let i = 0; i < props.section.length; i += 3) {
		rows.push(props.section.slice(i, i + 3))
	}
	return rows
})

const onClickItem = (item: ICampaignCard) => {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: GaGeneralPageName.MercariCampaign,
		button_name: 'Select Blog Post',
		event_extra: item.tracking,
	})
}
</script>
